import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { useGetCSLink } from "../Agent/ApplicationRejected/hooks/rejected.hooks";
import styles from "./style.module.scss";
import { CloseCircleFilled } from "@ant-design/icons";

const Blocked = () => {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const userCurrency = params.get("currency");

  const { data, isLoading, isError } = useGetCSLink({
    userCurrency: userCurrency,
    option: {
      enabled: userCurrency !== null,
    },
  });

  const onHandleCSCall = () => {
    if (!data) return;
    const csLinkValue = JSON.parse(data[0]?.value);
    window.location.href = csLinkValue.cs_url;
  };

  return (
    <div className={styles.container}>
      <CloseCircleFilled
        className={styles.cross}
        width={100}
        height={100}
        size={100}
      />
      {/* <Image height={121} fit={"contain"} src={rejectedImage} preview={false} /> */}
      <div className={styles.title}>{t("errorPage.blockedTitle")}</div>
      <div className={styles.subtitle}>{t("errorPage.blockedDesc")}</div>
      {isLoading ? (
        ""
      ) : isError ? (
        ""
      ) : (
        <div onClick={onHandleCSCall} className={styles.button}>
          {t("apply.contactCs")}
        </div>
      )}
    </div>
  );
};

export default Blocked;
